import React from "react";

//styles
import "./styles.scss"

const DetailsCard = ({
  info = " ",
  image = "image",
  title = "title",
  color = "green",
}) => {
  return (
    <div className="detailsCardContainer" style={{border:`1px solid ${color}`, color:`${color}`}}>
      <div className="topContainer">
        <div className="infoContainer">
          <p>{info}</p>
        </div>
        <div className="imgContainer" style={{backgroundColor:`${color}`}}>
          <img src={image} alt="logo" />
        </div>
      </div>
      <div className="bottomContainer">
        <p>{title}</p>
      </div>
    </div>
  );
};

export default DetailsCard;
